<div class="tutorial-stage spreadsheet" #stage>
  <div class="sheet" #viewport>
    <div class="grid">
      <!-- Header row (like Excel header with green fill) -->
      <div class="row header">
        <div class="cell">Number</div>
        <div class="cell">Rarity</div>
        <div class="cell">Condition</div>
        <div class="cell right">Quantity</div>
        <div class="cell right">Cardmarket Price</div>
      </div>

      <!-- Example rows -->
      <div class="row">
        <div class="cell">OP01-035</div>
        <div class="cell">R</div>
        <div class="cell">Near Mint Foil</div>

        <div class="cell right">
          <input
            #qty
            class="sheet-input"
            [class.active]="step === 'qty'"
            [value]="qtyValue"
            inputmode="numeric"
            autocomplete="off"
            spellcheck="false"
          />
        </div>

        <div class="cell right">
          <input
            #price
            class="sheet-input"
            [class.active]="step === 'price'"
            [value]="priceValue"
            inputmode="decimal"
            autocomplete="off"
            spellcheck="false"
          />
        </div>
      </div>

      <!-- Optional: show a few extra static rows to look like a sheet -->
      <div class="row faint">
        <div class="cell">OP01-073</div>
        <div class="cell">R</div>
        <div class="cell">Near Mint Foil</div>
        <div class="cell right"></div>
        <div class="cell right"></div>
      </div>

      <div class="row faint">
        <div class="cell">OP03-003</div>
        <div class="cell">R</div>
        <div class="cell">Near Mint Foil</div>
        <div class="cell right"></div>
        <div class="cell right"></div>
      </div>
    </div>
  </div>

  <!-- Cursor overlay -->
  <div
    class="cursor"
    [class.down]="cursorDown"
    [style.transform]="'translate(' + cursorX + 'px,' + cursorY + 'px)'"
    aria-hidden="true"
  ></div>
</div>
